module.exports = __webpack_public_path__ + "static/media/access-options.f852352d.png";